/*
 * @Descripttion:
 * @Author: sjq
 * @Date: 2021-03-12 15:05:17
 * @LastEditors: sjq
 * @LastEditTime: 2021-09-02 11:45:30
 */
import { request } from '@/utils/request'

export function logout() {
  return request({
    url: '/sgsf-user-center/auth/logout',
    method: 'delete'
  })
}

export function getUserInfo(token) {
  return request({
    url: '/sgsf-platform/user/info',
    method: 'get',
    params: { token }
  })
}

export function login(data) {
  //登录获取token
  return request({
    url: '/sgsf-user-center/auth/login',
    method: 'POST',
    data
  })
}
export function getPermissions(data) {
  //用token获取用户权限
  return request({
    url: '/sgsf-user-center/auth/permissions',
    method: 'GET',
    data
  })
}
